import { createInitialState } from "./state";
import type { ReviewComment } from "./types";

export const state = createInitialState();

export function findComment(id: string): ReviewComment | undefined {
  return state.allComments.find((comment) => comment.id === id);
}
